import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgLanguageSwitch32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M16 26.083c5.569 0 10.083-4.514 10.083-10.083S21.57 5.917 16 5.917 5.917 10.43 5.917 16 10.43 26.083 16 26.083M16 27C9.925 27 5 22.075 5 16S9.925 5 16 5s11 4.925 11 11-4.925 11-11 11M6.375 11.417h19.25v.916H6.375zM16 5c3.038 0 5.5 4.925 5.5 11 0 1.286-.11 2.52-.314 3.668l4.439-.001v.916l-4.624.001C20.132 24.37 18.218 27 16 27c-2.22 0-4.132-2.629-5.001-6.416H6.375v-.917h4.438A21.148 21.148 0 0 1 10.5 16c0-6.075 2.462-11 5.5-11m0 .917c-2.53 0-4.583 4.514-4.583 10.083S13.469 26.083 16 26.083c2.53 0 4.583-4.514 4.583-10.083S18.531 5.917 16 5.917m-9.625 13.75h19.25v.916H6.375z" /></SvgIcon>;
};
const Memo = memo(SvgLanguageSwitch32);
export default Memo;